import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';
import { CreateBookingMutation } from '../gql/graphql';

const createBookingMutation = graphql(/* GraphQL */ `
  mutation createBooking($input: BookingCreateInput!) {
    createBooking(input: $input) {
      bookingId
      tripId
      bookingState
    }
  }
`);

export type RoomDetail = {
  typeId: number; // Room type identifier
  numberOfRooms: number; // Number of rooms of this type
  pricePerRoom: number; // Price per room
};

export type BookingCreateInput = {
  tripId: number;
  bookingState: number;
  rooms: RoomDetail[]; // Updated to use RoomDetail objects
  email: string;
  fullName: string;
  gender: string;
  phone: string;
  paymentOption: number;
  numberOfGuests: number;
  /** Stripe PaymentIntent id for idempotent create after / with pay-now. */
  paymentIntentId?: string | null;
  /** Attach a new PaymentIntent to an existing booking (coupon retry). */
  existingBookingId?: number | null;
};

const useCreateBooking = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const mutation = useMutation<
    CreateBookingMutation,
    Error,
    BookingCreateInput
  >({
    mutationFn: async (input: BookingCreateInput) => {
      return graphqlRequest<CreateBookingMutation>(
        createBookingMutation,
        { input },
        isAuthenticated ? getAccessTokenSilently : undefined,
      );
    },
  });

  return mutation;
};

export default useCreateBooking;
